import { DialogV2 } from '@recruit-robin/robin-theme/web-components';
import { useEffect, useState } from 'react';

import { useNylasCalendarStore } from '../../lib';
import { InterviewType } from '../../model';
import { InterviewTypeSelection, InterviewValue } from '../interview-type-selection';
import { ManageConnection } from '../manage-connection';
import { useStyles } from './useModal.styles';

export const useModal = (data: {
  initialInterviewType?: InterviewType;
  onFinish?: (interviewType: InterviewType, interviewValue: InterviewValue) => void;
  onCancel?: () => void;
  skipManageConnection?: boolean;
  footer?: React.ReactNode;
}) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState<'manage-connection' | 'interview-type-selection'>('manage-connection');

  useEffect(() => {
    if (isOpen) {
      if (data.skipManageConnection) {
        setStep('interview-type-selection');
      }

      return () => {
        setStep('manage-connection');
      };
    }
  }, [isOpen]);

  const handleSelectInterviewType = (value: InterviewType, interviewValue: InterviewValue) => {
    useNylasCalendarStore.getState().setInterviewType(value);
    data.onFinish?.(value, interviewValue);
  };

  const handleConfirmManageConnection = () => {
    setStep('interview-type-selection');
  };

  const modal = (
    <DialogV2.Root isVisible={isOpen} customCss={classes.root}>
      <DialogV2.Backdrop />
      <DialogV2.Close onRequestClose={data.onCancel} />
      <DialogV2.Content customCss={classes.content}>
        {step === 'manage-connection' && (
          <ManageConnection onConfirm={handleConfirmManageConnection} onCancel={data.onCancel} footer={data.footer} />
        )}
        {step === 'interview-type-selection' && (
          <InterviewTypeSelection
            footer={data.footer}
            initialInterviewType={data.initialInterviewType}
            onConfirm={handleSelectInterviewType}
          />
        )}
      </DialogV2.Content>
    </DialogV2.Root>
  );

  return { modal, open: () => setIsOpen(true), close: () => setIsOpen(false) };
};
